import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaInstagram, FaFacebook } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6'; // Updated X icon

export default function Footer() {
  return (
    <footer className="bg-black text-white px-6 py-12 mt-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8">

        {/* What We Do */}
        <div>
          <h3 className="mb-4 font-semibold text-lg">What We Do</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/network">Network</Link></li>
          </ul>
        </div>

        {/* What We Serve */}
        <div>
          <h3 className="mb-4 font-semibold text-lg">What We Serve</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/our-expertise">Our Expertise</Link></li>
            <li><Link to="/who-we-serve">Who We Serve</Link></li>
          </ul>
        </div>

        {/* Careers & Contact */}
        <div>
          <h3 className="mb-4 font-semibold text-lg">Careers & Info</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/careers">Explore Open Positions</Link></li>
            <li><Link to="/joblist">Current Opportunities</Link></li>
          </ul>
        </div>

        {/* Who We Are */}
        <div>
          <h3 className="mb-4 font-semibold text-lg">Who We Are</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Company Info */}
        <div>
          <h3 className="mb-4 font-semibold text-lg">Company Info</h3>
          <h4>Main Branch Address:</h4>
          <p className="text-sm text-gray-300 mb-3">
            No.# 610 /B, 6th floor, Sandhya Techno-1 X-road, Radhe Nagar, khajaguda, Rai Durg, Hyderabad, Telangana-500081<br />
            <a href="https://www.adithyainfinity.com" className="text-cyan-400 hover:underline">www.adithyainfinity.com</a>
          </p>
          <div className="flex gap-4 text-xl mt-2">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
          </div>
        </div>
      </div>

      {/* Footer Bottom Legal Links */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-400">
        <p>&copy; {new Date().getFullYear()} V Adithya Pvt. Ltd. All rights reserved.</p>
        <p className="mt-1">
          <Link to="/privacy" className="hover:underline">Privacy Policy</Link> |{" "}
          <Link to="/cookies" className="hover:underline">Cookies</Link> |{" "}
          <Link to="/disclaimer" className="hover:underline">Disclaimer</Link> |{" "}
          <Link to="/legal-information" className="hover:underline">Legal Information</Link>
        </p>
      </div>
    </footer>
  );
}
